import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; 

import { PartialModule } from './partial/partial.module';
import { HomeModule } from './home/home.module';
import { ProductsModule } from './products/products.module';
import { BarModule } from './bar/bar.module';
import { ConnectModule } from './connect/connect.module';
import { OrderModule } from './order/order.module';
import { TermsModule } from './terms/terms.module';
import { NoticesModule } from './notices/notices.module';
import { PolicyModule } from './policy/policy.module';
import { UniversComponent } from './univers/univers.component';
import { GoldnGobPageComponent } from './goldn-gob-page/goldn-gob-page.component';
import { UiModule } from "../ui/ui.module";

@NgModule({
  declarations: [UniversComponent, GoldnGobPageComponent],
  imports: [
    CommonModule,
    RouterModule,
    PartialModule,
    UiModule
],
  exports: [
    PartialModule,
    HomeModule,
    ProductsModule,
    BarModule,
    TermsModule,
    PolicyModule,
    NoticesModule,
    ConnectModule,
    OrderModule,
    UniversComponent,
    GoldnGobPageComponent 
  ]
})
export class PageModule { }